<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <div class="item_title">运营</div>
        <!-- <el-input
          v-model="parameter.pitcher_name"
          style="width: 200px"
        /> -->
        <el-autocomplete
          v-model="displayGroupName"
          :fetch-suggestions="querySearchAsync"
          placeholder="请选择运营"
          clearable
          @select="handleGroupSelect"
          @clear="handleClear"
        />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-search"
        @click="search()"
      >搜索</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-bottom"
        @click="reportExport"
      >导出报表</el-button>
    </div>
    <div class="content1">
      <div>合计</div>
      <div>
        <div>消耗：</div>
        <div>{{ tableData.total_data && tableData.total_data.stat_cost ? tableData.total_data.stat_cost : 0 }}</div>
        <!--        <div-->
        <!--          v-if="total_data.rio !== 0"-->
        <!--          :class="{ color1: total_data.is_rio, color2: !total_data.is_rio }"-->
        <!--        >-->
        <!--          <div>{{ total_data.is_rio ? '↑' : '↓' }}</div>-->
        <!--          <div>-->
        <!--            {{ total_data.is_rio ? total_data.rio : total_data.rio * -1 }}%-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div>
        <div>小游戏/小程序当日广告变现ROI：</div>
        <div>{{ tableData.total_data && tableData.total_data.attribution_micro_game_0d_roi ? tableData.total_data.attribution_micro_game_0d_roi : 0 }}</div>
      </div>
      <div>
        <div>小游戏/小程序三日广告变现ROI：</div>
        <div>{{ tableData.total_data && tableData.total_data.attribution_micro_game_3d_roi ? tableData.total_data.attribution_micro_game_3d_roi : 0 }}</div>
      </div>
      <div>
        <div>小游戏/小程序七日广告变现ROI：</div>
        <div>{{ tableData.total_data && tableData.total_data.attribution_micro_game_7d_roi ? tableData.total_data.attribution_micro_game_7d_roi : 0 }}</div>
      </div>
      <div>
        <div>平均千次展示费用：</div>
        <div>{{ tableData.total_data && tableData.total_data.cpm_platform ? tableData.total_data.cpm_platform : 0 }}</div>
      </div>
      <div>
        <div>点击率：</div>
        <div>{{ tableData.total_data && tableData.total_data.ctr ? tableData.total_data.ctr : 0 }}</div>
      </div>
      <div>
        <div>激活数：</div>
        <div>{{ tableData.total_data && tableData.total_data.active ? tableData.total_data.active : 0 }}</div>
      </div>
      <div>
        <div>激活成本：</div>
        <div>{{ tableData.total_data && tableData.total_data.active_cost ? tableData.total_data.active_cost : 0 }}</div>
      </div>
      <div>
        <div>转化率：</div>
        <div>{{ tableData.total_data && tableData.total_data.conversion_rate ? tableData.total_data.conversion_rate : 0 }}</div>
      </div>
      <div>
        <div>平均转化成本：</div>
        <div>{{ tableData.total_data && tableData.total_data.conversion_cost ? tableData.total_data.conversion_cost : 0 }}</div>
      </div>
    </div>
    <div>
      <el-table
        ref="tableRef"
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        style="width: 100%"
        border
        @sort-change="sortChange"
      >
        <el-table-column
          prop="channel_date"
          label="日期"
          width="150"
          sortable="custom"
        />
        <el-table-column
          prop="operation_group_name"
          label="运营"
          width="150"
        />
        <el-table-column
          prop="stat_cost"
          label="消耗"
          width="150"
          sortable="custom"
        />
        <el-table-column
          prop="attribution_micro_game_0d_roi"
          label="小程序/小游戏首日广告变现ROI"
          width="150"
        />
        <el-table-column
          prop="attribution_micro_game_3d_roi"
          label="小程序/小游戏三日广告变现ROI"
          width="150"
        />
        <el-table-column
          prop="attribution_micro_game_7d_roi"
          label="小程序/小游戏七日广告变现ROI"
          width="150"
        />
        <el-table-column
          prop="cpm_platform"
          label="平均千次展示费用"
          width="150"
        />
        <el-table-column
          prop="ctr"
          label="点击率"
          width="150"
        />
        <el-table-column
          prop="active"
          label="激活数"
          width="150"
          sortable="custom"
        />
        <el-table-column
          prop="active_cost"
          label="激活成本"
          width="150"
        />
        <el-table-column
          prop="conversion_rate"
          label="转化率"
          width="150"
        />
        <el-table-column
          prop="conversion_cost"
          label="平均转化成本"
          width="150"
        />
        <el-table-column
          prop="roi_standard"
          label="roi标准"
          width="150"
        />
        <el-table-column
          prop="compliance_rate"
          label="roi达标率"
          width="150"
        />
      </el-table>
    </div>
    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import {
  exportReleaseData,
  modifyConsumption,
  oceanNovelReportbReleaseReport
} from '@/api/oceanNovelReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import { getSelectList } from '@/api/report/SelectData.js'
import { getOperationGroupList } from '@/api/oceanNovelReport.js'
// import { ElStep } from 'element-ui/types/step'
export default {
  components: {
    PaginationRight
    /* Details */
  },
  data() {
    return {
      tableData: {},
      total_data: {
        rio: null,
        income_roi_1_contrast: null,
        income_val_1_contrast: null,
        is_rio: false,
        in_roi: false,
        in_val: false
      },
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        pitcher_name: '',
        operation_group_id: ''
      },
      parameterNames: {
        pitcher_name: null
      },
      order_by: {}, // 表格数据排序
      current: null,
      date: [this.getNowFormatDate(window.Date.now()), this.getNowFormatDate(window.Date.now())],
      activeItem: null,
      nowDate: this.getNowFormatDate(window.Date.now()),
      activeText: null,
      drawerItem: {},
      displayGroupName: '' // 投放组显示名
    }
  },
  computed: {},
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList(obj = {}) {
      // console.log('parameter参数=======', this.parameter)
      if (JSON.stringify(this.order_by) === '{}') {
        this.order_by = {
          order: 'desc',
          field: 'channel_date'
        }
      }
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await oceanNovelReportbReleaseReport({
        ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      this.tableData = data.data
      this.loading = false
    },
    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 搜索
    search(value) {
      value || (this.parameter.page = 1)
      // 清空排序
      !value && (this.order_by.field || this.order_by.order) ? this.sortOrderChang() : null
      value === '导出' || this.getDataList(this.parameter)
      return this.parameter
    },
    // 清空排序
    sortOrderChang() {
      this.order_by = {}
      this.$refs.tableRef.clearSort()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        pitcher_name: null
      }
      this.date = []
      this.current = null
      this.sortOrderChang()
      this.getDataList()
    },

    // 导出报表
    async reportExport() {
      const obj = this.search('导出')
      await exportReleaseData({
        ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      // this.reset('no')
    },
    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await modifyConsumption({
            id: this.activeItem.id,
            cost: this.activeText
          })
          this.$message({
            message: '修改花费成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },

    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },

    handleSplicing(new_user_recharge_after_sp) {
      const arr = []
      for (const key in new_user_recharge_after_sp) {
        arr.push(`${key}: ${new_user_recharge_after_sp[key]}`)
      }
      // console.log('----------', new_user_recharge_after_sp)
      return arr
    },
    // 列表排序
    sortChange(cell) {
      console.log('cell:', cell)
      this.order_by['order'] = !cell.order ? cell.order : cell.order === 'ascending' ? 'asc' : 'desc'
      this.order_by['field'] = !cell.order ? cell.order : cell.prop
      this.search('排序')
    },
    querySearchAsync(queryString, cb) {
    // ⚠️ 搜索时传参要用 name
      getOperationGroupList({ name: queryString }).then(res => {
        const list = res.data.list.map(item => ({
          value: item.operation_group_name, // 展示
          id: item.id // 真实 ID
        }))
        cb(list)
      })
    },
    handleGroupSelect(item) {
      this.parameter.operation_group_id = item.id // 后端字段
      this.displayGroupName = item.value // 展示字段
    },
    handleClear() {
      this.parameter.operation_group_id = ''
      this.displayGroupName = ''
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
textarea {
  text-align: left;
  white-space: pre-line;
}
.content {
  .item {
    display: flex;
    align-items: center;

    .item_title {
      display: inline-block;
      width: 100px;
    }

    .item_input {
      width: 200px;
    }
  }
}

.selectionArea {
  display: flex;
  flex-wrap: wrap;

  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;

    .item_title {
      margin-right: 10px;
      display: inline-block;
    }
  }
}

.powder {
  background: rgb(248, 216, 216);
}

.green {
  background: rgb(52, 229, 54);
}

.yellow {
  background: rgb(255, 247, 173);
}

.blue {
  background: rgb(158, 211, 252);
}

.red {
  background: #ffa500;
}

.magRig {
  margin-right: 10px;
}

.magLfte {
  margin-left: 10px;
}

.chong {
  display: inline-block;
  width: 13px;
  height: 86%;
  margin-left: 6px;
}

.mybox {
  margin-left: 20px;
  display: flex;
  align-items: center;
}
</style>

<style>
.publicItems .el-dialog {
  margin-top: 6vh !important;
}

.content1 {
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}

.content1 > div:nth-child(1) {
  margin-right: 7rem;
}

.content1 > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}

.content1 > div > div:nth-child(2) {
  color: rgb(138, 37, 37);
}

.content1 > div > div:nth-child(3) {
  display: flex;
  align-items: flex-end;
  font-weight: bolder;
  margin-left: 10px;
}

.content1 > div > div > div:nth-child(2) {
  font-size: 0.5rem;
  margin-left: 2px;
}

.color2 {
  color: #0ebb0e;
}

.color1 {
  color: #ef0505;
}

/* .el-table ::v-deep.el-table_1_column_14 ::v-deep.sort-caret.descending {
  border-top-color: #1890ff;
} */
</style>
